export const resolveBmiDisplayValue = (bmi: number): number =>
	Math.round(bmi * 10) / 10
